import React from "react";
import { IconType } from "./types";

const Package: IconType = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g opacity="0.96">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4465 36.4068H19.2192C18.9129 36.4068 18.6661 36.2575 18.6661 36.0734C18.6661 35.8894 18.9129 35.7401 19.2192 35.7401H21.4465C21.7527 35.7401 21.9995 35.8894 21.9995 36.0734C21.9995 36.2575 21.7527 36.4068 21.4465 36.4068Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7973 38.4068H19.8686C19.5719 38.4068 19.3329 38.2575 19.3329 38.0734C19.3329 37.8894 19.5719 37.7401 19.8686 37.7401H24.7973C25.0931 37.7401 25.333 37.8894 25.333 38.0734C25.333 38.2575 25.0931 38.4068 24.7973 38.4068Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7973 39.7401H19.8686C19.5719 39.7401 19.3329 39.5908 19.3329 39.4067C19.3329 39.2227 19.5719 39.0734 19.8686 39.0734H24.7973C25.0931 39.0734 25.333 39.2227 25.333 39.4067C25.333 39.5908 25.0931 39.7401 24.7973 39.7401Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.739 49.2301C48.739 49.6533 48.3844 49.997 47.9469 49.997H37.0307L37.0316 45.7548C37.0316 45.7531 37.0307 45.7514 37.0307 45.7497V45.7082C37.0307 44.9698 36.4195 44.3704 35.6666 44.3704H28.4569C27.7049 44.3704 27.0928 44.9698 27.0928 45.7082V49.997H15.9013C15.4638 49.997 15.1092 49.6533 15.1092 49.2301V25.6176H27.0251H27.0928V29.6076C27.0928 30.3157 27.7049 30.8926 28.4569 30.8926H35.6666C36.4195 30.8926 37.0307 30.3157 37.0307 29.6076L37.028 25.6176H37.1002H48.739V49.2301ZM35.9205 49.997H28.2029L28.2038 45.7548C28.2038 45.6106 28.3179 45.4932 28.4577 45.4932H35.6684C35.8065 45.4932 35.9187 45.6098 35.9205 45.7523V49.997ZM20.5592 14.6797C20.6474 14.5174 20.8185 14.4146 21.0047 14.4137L28.3677 14.4094L27.1533 24.5415H15.4548L20.5592 14.6797ZM35.9205 25.6176V29.6076C35.9205 29.7224 35.8064 29.8166 35.6666 29.8166H28.4568C28.3169 29.8166 28.2029 29.7224 28.2029 29.6076L28.2002 25.6176H35.9205ZM34.7569 15.4423L35.8537 24.5415H28.2715L29.4868 14.4103L34.6331 14.4155L34.7569 15.4423ZM42.7989 14.425C42.9931 14.425 43.1677 14.5295 43.256 14.7005L48.3915 24.5415H36.971L35.7513 14.4189L42.7989 14.425ZM49.7895 24.8369L44.2476 14.2168C43.9714 13.6822 43.4181 13.3497 42.8007 13.3489L35.6212 13.3428V13.3411L28.9915 13.3333H28.9781H28.497V13.3342L21.0013 13.3377C20.3999 13.3411 19.8519 13.665 19.5712 14.1901L14.0579 24.8386C14.0196 24.9137 14 24.9958 14 25.0796V49.2301C14 50.2466 14.8527 51.0731 15.9013 51.0731H27.0928H27.6479H36.4757H37.0307H47.9469C48.9956 51.0731 49.8492 50.2466 49.8492 49.2301V25.0796C49.8492 24.9958 49.8287 24.912 49.7895 24.8369Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7905 41.3161H25.5417V34.1632H17.7905V41.3161ZM25.6248 33.0735H17.7093C17.1345 33.0735 16.6661 33.5269 16.6661 34.0845V41.3958C16.6661 41.9533 17.1345 42.4067 17.7093 42.4067H25.6248C26.1996 42.4067 26.6662 41.9533 26.6662 41.3958V34.0845C26.6662 33.5269 26.1996 33.0735 25.6248 33.0735Z"
        fill="black"
      />
    </g>
  </svg>
);

export default Package;
